import web from "@/core/middlewares/web";

let index = () => import(/* webpackChunkName: "roles" */ '@/views/roles/Index');
let create = () => import(/* webpackChunkName: "roles" */ '@/views/roles/Create');
let edit = () => import(/* webpackChunkName: "roles" */ '@/views/roles/Edit');


export default [
    {
        path: "roles",
        name: "roles.index",
        component: index,
        meta: {
            middleware: web,
            permissions: ['roles:viewAny'],
            title: "سطح دسترسی"
        }
    },
    {
        path: "roles/create",
        name: "roles.create",
        component: create,
        meta: {
            middleware: web,
            permissions: ['roles:create'],
            title: "ایجاد نقش"
        }
    },
    {
        path: "roles/:role",
        name: "roles.edit",
        component: edit,
        meta: {
            middleware: web,
            permissions: ['roles:update'],
            title: "ویرایش نقش"
        }
    },

]